module.exports = __webpack_public_path__ + "img/news1-6.2e5186b2.png";